import { TAG } from "../constants";
import { OneTimeProduct, ProductBillingModel, Titration } from "../types";
import { patientApi } from "./patientApi";

export const titrationApi = patientApi.injectEndpoints({
  endpoints: (builder) => ({
    getTitrationForProduct: builder.query<Titration, string>({
      query: (slug) => ({
        url: `/api/patient/titration/${slug}`,
        method: "GET",
      }),
      providesTags: (_returns, _error, args) => [
        {
          type: TAG.PRODUCT_TITRATION,
          id: args,
        },
      ],
    }),
    getRecommendedDose: builder.query<
      OneTimeProduct,
      void | { billing_model?: ProductBillingModel; product_id?: number }
    >({
      query: (params) => ({
        method: "GET",
        url: `/api/patient/titration/recommended`,
        params: {
          billing_model: params?.billing_model ?? undefined,
          product_id: params?.product_id ?? undefined,
        },
      }),
    }),
  }),
});

export const { useGetTitrationForProductQuery, useGetRecommendedDoseQuery } =
  titrationApi;
